import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { CmsConfig, ConfigModule, I18nModule } from '@spartacus/core';
import { AtgPriceListComponent } from './atg-price-list.component';
import { SpinnerModule } from '@spartacus/storefront';
import { KnBrCustomerContextGuard } from 'src/shared/guards/kn-br-customer-context.guard';



@NgModule({
  declarations: [AtgPriceListComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    I18nModule,
    NgSelectModule,
    SpinnerModule,
    ConfigModule.withConfig({
         cmsComponents: {
           PriceListRequestComponent: {
             component: () => import('./atg-price-list.component').then((c) => c.AtgPriceListComponent),
             guards: [KnBrCustomerContextGuard],
           },
         },
       } as CmsConfig),
  ]
})
export class AtgPriceListModule { }
